const DisplayModes = {
  event_count: "Comptage d'événements",
  congestion_rate: "Taux de congestion",
};

const RoadNetworks = {
  graphe_routier_grand_geneve: "Grand Genève",
  segments_infomobilite: "Segments Infomobilité",
};

const yAxisOptionsValueToLabel = {
  reliability: "fiabilité",
  n_thumbs_up: "# thumbs up",
  delay_minutes: "retard [min]",
  congestion_coefficient: "coeff. de congestion",
  travel_time_minutes: "temps de parcours [min]",
};

export { DisplayModes, RoadNetworks, yAxisOptionsValueToLabel };
